/*
 * The panel speaks four languages and the browser needs one of them.
 *
 * All four were imported here, so every visit downloaded and parsed 250KB of
 * JSON - three quarters of it for languages that session would never render -
 * before the first screen could be drawn. English is kept in the bundle
 * because it is the fallback and the default, and the other three are fetched
 * as their own chunk the moment they are actually chosen.
 *
 * Switching language goes through setLocale(), which resolves once the words
 * are in place. main.js waits on it before mounting, so a school working in
 * Arabic still gets Arabic on the first frame rather than a flash of English.
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './locales/en.json'

Vue.use(VueI18n)

const savedLang = localStorage.getItem("lang") || "en";

const i18n = new VueI18n({
  //always start on a locale whose words are already here
  locale: 'en',
  fallbackLocale: 'en',
  messages: { en },
})

const loaded = ['en'];

/**
 * Make a locale current, fetching its words first if this is the first time.
 *
 * @returns {Promise} resolved once the locale is in use
 */
export function setLocale(locale) {
  if (loaded.indexOf(locale) !== -1) {
    i18n.locale = locale;

    return Promise.resolve(locale);
  }

  return import(/* webpackChunkName: "locale-[request]" */ `./locales/${locale}.json`)
    .then((messages) => {
      i18n.setLocaleMessage(locale, messages.default || messages);
      loaded.push(locale);
      i18n.locale = locale;

      return locale;
    })
    .catch(() => {
      //a missing chunk must not leave the panel wordless: English is loaded
      i18n.locale = 'en';

      return 'en';
    });
}

/** Resolves when the language saved from last time is ready to render. */
export const localeReady = setLocale(savedLang);

export default i18n
